/* tslint:disable:prefer-for-of */
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NinjaData } from '../../../models/ninja-data.model';
import { map } from 'rxjs/operators';
import { SharedService } from '../../shared.service';
import { DataService } from '../../../core/data.service';
import { forkJoin, Observable, zip } from 'rxjs';
import { CountryHistoricalData } from '../../../models/country-historical-data.model';
import { UtilityService } from '../../../core/utility.service';

@Component({
  selector: 'app-country-details',
  templateUrl: './country-details.component.html',
  styleUrls: ['./country-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class CountryDetailsComponent {

  constructor(
    private dataService: DataService,
    private sharedService: SharedService,
    private activatedRoute: ActivatedRoute,
    private utilityService: UtilityService
  ) {
    this.fetchCountryName();
  }

  isDelta = false;
  countryName = this.fetchCountryName();
  cumulativeData$: Observable<NinjaData> = this.dataService.getCountryDetails(this.countryName);
  historicalData$ = this.dataService.getCountryHistoricalData(this.countryName);
  vaccineData$ = this.dataService.getVaccinesCoverageByCountry(this.countryName);

  dates$: Observable<string[]> = this.historicalData$
    .pipe(
      map((data: CountryHistoricalData) => {
        return Object.keys(data.timeline.cases);
      })
    );
  cases$: Observable<number[]> = this.historicalData$
    .pipe(
      map((data: CountryHistoricalData) => {
        return Object.values(data.timeline.cases);
      })
    );
  deaths$: Observable<number[]> = this.historicalData$
    .pipe(
      map((data: CountryHistoricalData) => {
        return Object.values(data.timeline.deaths);
      })
    );
  recovered$: Observable<number[]> = this.historicalData$
    .pipe(
      map((data: CountryHistoricalData) => {
        return Object.values(data.timeline.recovered);
      })
    );

  deltaCases$: Observable<number[]> = this.utilityService.calculateDelta(this.cases$);

  deltaDeaths$: Observable<number[]> = this.utilityService.calculateDelta(this.deaths$);

  mortalityRate$: Observable<number[]> = zip(this.cases$, this.deaths$)
    .pipe(
      map(data => {
        const mortalityRate = [];
        const cases = data[0];
        const deaths = data[1];
        cases.forEach((c, i) => {
          mortalityRate.push((deaths[i] / cases[i]) * 100).toFixed(2);
        });
        return mortalityRate;
      })
    );

  vaccines$: Observable<number[]> = this.vaccineData$
    .pipe(
      map((data: CountryHistoricalData) => {
        return Object.values(data.timeline);
      })
    );

  vaccinesDelta$: Observable<number[]> = this.utilityService.calculateDelta(this.vaccines$);

  vaccinesDates$: Observable<string[]> = this.vaccineData$
    .pipe(
      map((data: CountryHistoricalData) => {
        return Object.keys(data.timeline);
      })
    );

  forkedData$ = forkJoin({
    cumulativeData: this.cumulativeData$,
    timeSeriesDates: this.dates$,
    timeSeriesCases: this.cases$,
    timeSeriesDeaths: this.deaths$,
    timeSeriesRecovered: this.recovered$,
    timeSeriesDeltaCases: this.deltaCases$,
    timeSeriesDeltaDeaths: this.deltaDeaths$,
    historicalMortalityRate: this.mortalityRate$,
    vaccinesTimeSeries: this.vaccines$,
    vaccinesTimeSeriesDelta: this.vaccinesDelta$,
    vaccinesDates: this.vaccinesDates$
  });

  private fetchCountryName(): string {
    return this.activatedRoute.snapshot.paramMap.get('name');
  }

}
